import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, Renderer2, OnDestroy } from '@angular/core';
import { MainService } from '../../services/optimizer-service/optimizer.service';
import { QuickDialog } from '../../utilities/Dialog/QuickDialog';
import { MatCheckboxChange, MatDialog } from '@angular/material';
import { Trip } from '../../DataStructures/Trip/Trip';
import { ArrayUtils } from '../../utilities/ArrayUtils/ArrayUtils';
import { Area } from '../../DataStructures/Area/Area';
import { MapControls } from '../../utilities/MapControls/MapConrols';
import { FormControl } from '@angular/forms';
import { DirectionsService } from '../../utilities/DirectionsService/DirectionsService';
import { ActivatedRoute } from '@angular/router';
declare var Print: any

@Component({
  selector: 'app-driver-route',
  templateUrl: './driver-route.component.html',
  styleUrls: ['./driver-route.component.scss'],
  host: { 'class': 'driver-route-comp' }
})
export class DriverRouteComponent implements OnInit, AfterViewInit, OnDestroy {
  jaLat = 18.1350138;
  jaLng = -77.1981928;
  tripId: string;
  passengers: Array<Area> = [];
  trip: Trip;
  urls = new Array<string>();
  panelHeight;
  searchType = "trip";
  companyid;
  locationid;
  users = [];
  filteredUsers = [];
  searchControl = new FormControl('');
  overlay = false;
  directionsMarkers = [];
  @ViewChild('map') mapReference: ElementRef;
  @ViewChild('searchInput') searchInput: ElementRef;

  constructor(
    private optimizerService: MainService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private directionsService:DirectionsService,
    public mapControls: MapControls,
    private renderer: Renderer2) { }


  getLocation() {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            resolve({
              lat: latitude,
              lng: longitude
            })
          },
          (error) => {
            resolve({
              lat: this.jaLat,
              lng: this.jaLng
            })
          }
        );
      } else {
        resolve({
          lat: this.jaLat,
          lng: this.jaLat
        })
      }
    });
  }

  ngAfterViewInit(): void {
    this.mapControls.initialize(this.mapReference);
    this.getLocation().then((coords: any) => {
      this.mapControls.createMapAndCenterOnLoaction(coords.lat, coords.lng, true, false);
      this.mapControls.map.setZoom(15);
    })
    document.addEventListener("DOMContentLoaded", function () {
      const draggableElement = document.getElementById("bottomPanel");
      const draggable = document.getElementById("draggable");
      const seatPassengers = document.getElementById("seats-and-passengers");
      const panelContent = document.getElementById("panel-content");
      panelContent.style.height = (draggableElement.offsetHeight - seatPassengers.offsetHeight) + 'px';
      draggableElement.style.transform = `translateY(${50}%)`;
      let offsetY, isDragging = false;

      // Function to handle the start of the drag
      function startDrag(event) {
        isDragging = true;
        offsetY = (event.clientY ? event.clientY : event.touches[0].clientY) - draggableElement.getBoundingClientRect().top;
      }

      // Function to handle the drag movement
      function drag(event) {
        if (isDragging) {
          const y = (event.clientY ? event.clientY : event.touches[0].clientY) - offsetY;
          const maxHeight = window.innerHeight * 0.95;
          const newY = Math.min(Math.max(0, y), maxHeight);
          draggableElement.style.transform = `translateY(${newY}px)`;
        }
      }

      // Function to handle the end of the drag
      function endDrag() {
        isDragging = false;
      }

      // Add event listeners for drag-and-drop
      draggable.addEventListener("mousedown", startDrag);
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", endDrag);

      draggable.addEventListener("touchstart", startDrag);
      document.addEventListener("touchmove", drag, null);
      document.addEventListener("touchend", endDrag);
    });
  }

  ngOnInit() {
    this.renderer.setStyle(document.body, 'overflow', 'hidden');
    this.tripId = this.route.snapshot.queryParams.tripid;
    if (this.tripId) {
      this.search();
    }
  }

  viewRoundTrip(trip: Trip, ordered = true) {
    trip.getDirectionsGoogle(this.directionsService, {
      avoidTolls: true,
      orderwaypoints: ordered,
      splitDirections: true
    }).then(res => {
      this.showTripOnMap(res);
    }).catch(e => {
      alert("Error getting directions:" + e);
    })
  }

  private showTripOnMap(trip: Trip) {

    this.mapControls.clearMarkers();
    this.mapControls.directionsDisplay.setDirections(trip.legs[trip.currentLegIndex]);
    this.directionsMarkers = this.mapControls.addDirectionsMarkers(trip, null);
  }

  nextLeg() {
    if (this.trip) {
      this.trip.nextLeg();
      this.showTripOnMap(this.trip);
    }

  }

  prevLeg() {
    if (this.trip) {
      this.trip.prevLeg();
      this.showTripOnMap(this.trip);
    }
  }

  ngOnDestroy(): void {
    this.renderer.removeStyle(document.body, 'overflow');
  }

  getPlacehodler() {
    if (this.searchType == 'trip') {
      return "Enter Trip ID....";
    } else {
      return "Enter Passenger Name....";
    }
  }

  onCheckboxChange(event: MatCheckboxChange, passenger: Area) {
    if (event.checked) {
      if (!this.trip.loadPassenger(passenger)) {
        new QuickDialog(this.dialog).InfoDialog("No more seats remaining to add passenger.", "Max Capacity", "OK");
      }
    } else {
      this.trip.unloadPassenger(passenger);
    }
  }

  getAvailableSeats() {

    if (this.trip) {
      this.trip.getAreaLegMapping
    } else {
      return 0;
    }
  }



  updateTrip() {
    if (this.trip == null) {
      new QuickDialog(this.dialog).InfoDialog("Enter a trip ID in the search bar and search for a trip to get started.", "Oops", "OK");
      return;
    }
    if (this.trip.loadedPassengers.length <= 0) {
      new QuickDialog(this.dialog).InfoDialog("You have not checked off any passengers, you have to check off at least one passenger.", "No Passengers", "OK");
      return;
    }
    let unchecked = this.trip.areas.length - this.trip.loadedPassengers.length;
    let message = "";
    if (unchecked > 0) {
      message = `${unchecked} PASSENGERS ARE UNCHECKED AND WILL BE REMOVED FROM THE TRIP. ARE YOU SURE YOU WANT TO CONTINUE?`;
    } else {
      message = "All passengers are checked and no one is left off, continue?";
    }
    new QuickDialog(this.dialog).
      DecisionDialog({
        message: `${message}`,
        options: [
          {
            code: 'yes',
            message: "Yes, save trip",
            icon: 'fa-thumbs-up'
          },
          {
            code: 'no',
            message: 'No, cancel',
            icon: 'fa-ban'
          }
        ]
      }).then(async (choice) => {
        if (choice == 'yes') {
          await this.optimizerService.updateTrip(this.trip);
          new QuickDialog(this.dialog).InfoDialog("The trip has been updated successfully.", "Updated", "OK");
        }
      });
  }

  getTrip() {
    if (this.tripId == null) {
      new QuickDialog(this.dialog).InfoDialog("Please enter the trip id", "Oops", "OK");
      return;
    }
    if (this.tripId.trim() == "") {
      new QuickDialog(this.dialog).InfoDialog("Please enter the trip id", "Oops", "OK");
      return;
    }

    let d = new QuickDialog(this.dialog).LoadingDialog("Fetching trip....");
    this.optimizerService.getTrip(this.tripId).then((data: any) => {
      d.close();
      if (data.status) {
        if (data.data != null) {
          if (!Array.isArray(data.data)) {
            this.searchInput.nativeElement.value = '';
            this.urls = this.buildUrls(data.data);
            this.trip = Trip.createTripFromRawTripData(data.data);
            this.passengers = this.trip.areas;
            if (this.trip.areas.length > 0) {
              this.companyid = this.trip.areas[0].companyid;
              this.locationid = this.trip.areas[0].locationid;
              this.viewRoundTrip(this.trip);
            } else {
              this.companyid = this.trip.companyid;
              this.locationid = this.trip.locationid;
            }
            this.optimizerService.getUsersByCompany(this.companyid).then((results) => {
              this.users = results.data;
            });
          } else {
            new QuickDialog(this.dialog).InfoDialog("We Did not find a trip with that id", "Not found", "OK");
          }
        } else {
          new QuickDialog(this.dialog).InfoDialog("We Did not find a trip with that id", "Not found", "OK");
        }

      } else {
        new QuickDialog(this.dialog).InfoDialog("Please try again", "Oops", "OK");
      }
    }).catch(e => {
      d.close();
      console.log(e);
      new QuickDialog(this.dialog).InfoDialog("Please try again", "Oops", "OK");
    });
  }

  setSearchType(type) {
    this.searchType = type;
    this.enableOverlay();
  }

  enableOverlay() {
    if (this.searchType == 'passenger') {
      let overlay = document.getElementById('search-overlay');
      let topNav = document.getElementById('top-nav');
      overlay.style.zIndex = '3';
      topNav.style.zIndex = '4';
      this.overlay = true;
    }
  }

  disableOverlay() {
    let overlay = document.getElementById('search-overlay');
    let topNav = document.getElementById('top-nav');
    overlay.style.zIndex = '0';
    topNav.style.zIndex = '2';
    this.overlay = false;
    this.filteredUsers = [];

  }

  search() {
    if (this.searchType == 'trip') {
      this.getTrip();
    } else {

    }
  }

  onKeyDown(event: KeyboardEvent): void {
    if (this.searchInput.nativeElement.value.length >= 3) {
      this.filteredUsers = this.users.filter(x =>
        (`${x.firstname} ${x.lastname}`).includes(this.searchInput.nativeElement.value)
        ||
        (`${x.employeeid}`).includes(this.searchInput.nativeElement.value)
      );
    }
  }

  getTripTime() {
    if (this.trip) {
      let hourMin = this.optimizerService.secondsToHoursAndMinutes(this.trip.time);
      return `${hourMin.hours > 0 ? hourMin.hours + "h" : ""} ${hourMin.minutes > 0 ? hourMin.minutes + "m" : ""}`;
    } else {
      return "0h 0m";
    }
  }

  async removePassenger(passenger: Area) {
    let d = new QuickDialog(this.dialog).LoadingDialog("Removing Passenger...");
    this.trip.removePassenger(passenger);
    await this.trip.calculateDirections(this.optimizerService);
    this.viewRoundTrip(this.trip);
    d.close();
  }

  addPassenger(user) {
    let d = new QuickDialog(this.dialog).LoadingDialog("This may take a few seconds....");
    this.optimizerService.optimizePassengerPosition(this.trip, user.userid).then((res) => {
      if (res.data) {
        new QuickDialog(this.dialog).
          DecisionDialog({
            message: `Adding this passenger will extend the trip duration by 
            ${Math.round(((res.data.time - this.trip.time) / 60))} minutes. Continue?`,
            options: [
              {
                code: 'yes',
                message: "Yes, add passenger",
                icon: 'fa-thumbs-up'
              },
              {
                code: 'no',
                message: 'No, cancel addition',
                icon: 'fa-ban'
              }
            ]
          }).then(async (choice) => {
            if (choice == 'yes') {
              let d = new QuickDialog(this.dialog).LoadingDialog("Recalculating trip time...");
              this.trip.addPassengerAtIndex([res.data.area], res.data.index);
              await this.trip.calculateDirections(this.optimizerService);
              this.viewRoundTrip(this.trip);
              d.close();
            }
          });
      }
      d.close();
    }).catch((e) => {

      d.close();
      console.log(e);
      if (e.status == 400) {
        let body = JSON.parse(e._body);
        new QuickDialog(this.dialog).InfoDialog(body.message, "Unable to add passenger", "OK");
      } else {
        new QuickDialog(this.dialog).InfoDialog("There was an issue adding the passenger", "Unable to add passenger", "OK");
      }
    })
  }

  openUrl(url) {
    // Open the link in a new tab
    window.open(url, '_blank');
  }

  buildUrls(trip: Trip): Array<string> {

    trip = Trip.createTripFromRawTripData(trip);

    var subTrips = ArrayUtils.divideArray(trip.areas, 8);


    var urls = [];

    var source = trip.source;
    var finalDestination = trip.destination;



    for (var i = 0; i < subTrips.length; i++) {

      if (i == 0) {
        subTrips[i].unshift(source);
      }
      if (i == (subTrips.length - 1)) {
        subTrips[i].push(finalDestination);
      } else {
        subTrips[i].push(subTrips[i + 1].slice(0, 1)[0]);
      }
    }

    for (var i = 0; i < subTrips.length; i++) {

      var areas: Array<Area> = subTrips[i];
      var origin = areas[0].getLatLng();
      var destination = areas[areas.length - 1].getLatLng();
      var url = "https://www.google.com/maps/dir/?api=1&origin=";
      url = url += areas[0].getLatLng().lat + "," + areas[0].getLatLng().lng;
      url = url += "&waypoints=";


      for (var j = 1; j < (areas.length - 1); j++) {
        var a = areas[j];
        var dest = a.getLatLng();
        url = url += "" + dest.lat + "," + dest.lng + "|";
      }

      url = url += "&destination=" + destination.lat + "," + destination.lng;
      url = url += "&travelmode=driving";
      url = url += "&dir_action=navigate";

      urls.push(url);
    }

    return urls;
  }

}
